export default "/institutions/ailos.svg";